// Versandfähigkeit einer Mail im Composer — reine Regeln, damit sie testbar sind
// und Knopf-Zustand und Absende-Prüfung nicht auseinanderlaufen können.
//
// Wichtig: Eine Mail NUR mit Bcc-Empfängern ist gültig. Genau das ist der Fall
// „Handwerker beauftragen": mehrere Betriebe bekommen dieselbe Anfrage, ohne die
// Adressen der anderen zu sehen (Fehlerbild 2026-08-05 — vorher zwang die Prüfung
// dazu, sich selbst ins An-Feld zu setzen).

export function anzahlEmpfaenger(an: unknown[], cc: unknown[], bcc: unknown[]): number {
  return an.length + cc.length + bcc.length;
}

/** Fehlertext, wenn die Mail so nicht verschickt werden kann — sonst null. */
export function versandFehler(
  an: unknown[], cc: unknown[], bcc: unknown[], betreff: string,
): string | null {
  if (anzahlEmpfaenger(an, cc, bcc) === 0) return 'Bitte mindestens einen Empfänger angeben (An, Cc oder Bcc).';
  if (!betreff.trim()) return 'Bitte einen Betreff angeben.';
  return null;
}
